import {createWidgetPreloader} from '../source/preloader'

///////////////////////////////////////////////////////////////////////////////

let widgetPreloader = createWidgetPreloader({
  resolvers: {
    initialConfig: async () => {
      return {
        customConfig: require('../config/config.**.yml'),
      }
    },
    preloaderCSS: () => import('./styles/preloader'),
    widgetCSS: () => import('./styles/widget'),
  },
})

///////////////////////////////////////////////////////////////////////////////

widgetPreloader.events.beforePaymentSend.subscribe((event) => {
  let api = event.data.api
  let data = api.paymentForm.data

  if (data.stored_customer_donation_receipt_select) {
    data.stored_customer_donation_receipt = data.stored_customer_donation_receipt_select === 'truth'
    delete data['stored_customer_donation_receipt_select']
  }
})

///////////////////////////////////////////////////////////////////////////////

window['rnw'] = window['rnw'] || {}
window['rnw']['tamaro'] = widgetPreloader
